import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRight } from '@fortawesome/pro-solid-svg-icons/faArrowUpRight';
import type { ContentTypeChipView } from 'shared/panda/messages/doc-answer';
import { ContentTypeChip } from './content-type-chip';
import styles from './answer-card.module.scss';

interface SourceFooterProps {
  chip: ContentTypeChipView | null;
  to: string;
  label: string;
  onClick?: () => void;
  isHub?: boolean;
  /** Screen-reader name for the link when the label alone is ambiguous (several rows). */
  ariaLabel?: string;
  focusable?: boolean;
}

export function SourceFooter({
  chip,
  to,
  label,
  onClick,
  isHub = false,
  ariaLabel,
  focusable = true,
}: SourceFooterProps) {
  return (
    <div className={styles.sourceFooter}>
      {chip && <ContentTypeChip chip={chip} isHub={isHub} />}
      <Link
        className={styles.openLink}
        to={to}
        aria-label={ariaLabel}
        tabIndex={focusable ? undefined : -1}
        onClick={onClick}>
        {label}
        <FontAwesomeIcon icon={faArrowUpRight} className={styles.openIcon} />
      </Link>
    </div>
  );
}
